import { ShieldCheck, KeyRound, Server, FileText, XCircle, Eye } from "lucide-react";
import { Link } from "react-router-dom";

const pillars = [
  {
    icon: ShieldCheck,
    title: "Draft-first publishing",
    body:
      "Every write action — publish, pause, modify — requires an explicit confirmation in your chat. Nothing goes live until you say yes.",
  },
  {
    icon: Eye,
    title: "Daily spend caps",
    body:
      "Campaigns ship with daily budgets you set up front. We never raise a budget without your explicit instruction.",
  },
  {
    icon: KeyRound,
    title: "Encrypted OAuth tokens",
    body:
      "Your Google Ads token is encrypted at rest in our US-hosted Supabase database (us-west-1). We never see your Google password.",
  },
  {
    icon: Server,
    title: "SCC-protected transfers",
    body:
      "Personal data is stored in the United States. For EU/UK users, transfers are governed by Standard Contractual Clauses with supplementary safeguards (Schrems II compliant).",
  },
  {
    icon: FileText,
    title: "30-day audit log",
    body:
      "Every tool call your AI makes is logged with timestamp, tool, and sanitised arguments — viewable on request, deleted after 30 days.",
  },
  {
    icon: XCircle,
    title: "Revoke any time",
    body:
      "Disconnect Upfixe from your Google account in one click. Account and audit-log deletion completes within 30 days of request.",
  },
];

const McpSafetySection = () => {
  return (
    <section className="py-20 px-4 bg-background border-b border-border">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Safety &amp; data
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Giving an AI access to your ad spend should not require a leap of
            faith. Here's exactly how Upfixe keeps you in control.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {pillars.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="rounded-lg border border-border bg-card text-card-foreground p-6"
            >
              <div className="h-10 w-10 rounded-md bg-primary/10 text-primary flex items-center justify-center mb-4">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">{title}</h3>
              <p className="text-sm text-muted-foreground">{body}</p>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-muted-foreground">
          Full detail in our{" "}
          <Link to="/privacy" className="text-primary hover:underline">
            privacy policy
          </Link>{" "}
          and{" "}
          <Link to="/terms" className="text-primary hover:underline">
            terms of service
          </Link>
          .
        </p>
      </div>
    </section>
  );
};

export default McpSafetySection;
